// 旅居房型（Mock）
// 房型挂在小区下：户型图、适住人数、面积、一句话描述、设施标签
// 旅居是咨询制：无价格、无库存、无预订按钮

export const STAY_ROOM_STATUS = [
  { value: 1, label: '展示', tagType: 'success' },
  { value: 0, label: '下架', tagType: 'info' }
]

// 所属小区选项（与旅居小区列表一致）
export const ROOM_COMMUNITY_OPTIONS = [
  { value: 1, label: '象山颐园' },
  { value: 2, label: '漓江雅苑' },
  { value: 3, label: '石林康郡' }
]

// 房内设施标签快捷选项（可自由输入）
export const ROOM_FACILITY_PRESETS = ['大床', '双床', '免费WIFI', '空调', '电视', '洗衣机', '冰箱', '热水器', '电梯']

export const STAY_ROOM_LIST = [
  {
    id: 1,
    community_id: 1,
    name: '两房两厅一卫',
    image: '',
    suitable_guests: '2-3人',
    area: '约76㎡',
    description: '雅致见山，清风入室，适合家庭或结伴旅客',
    facilities: ['大床', '免费WIFI', '空调', '电视'],
    sort: 10,
    status: 1,
    created_at: '2026-09-05 09:00:00',
    updated_at: '2026-09-05 09:00:00'
  },
  {
    id: 2,
    community_id: 1,
    name: '一房一厅一卫',
    image: '',
    suitable_guests: '1-2人',
    area: '约48㎡',
    description: '小而精致，日出江雾尽收眼底',
    facilities: ['大床', '免费WIFI', '空调', '冰箱'],
    sort: 20,
    status: 1,
    created_at: '2026-09-05 09:10:00',
    updated_at: '2026-09-05 09:10:00'
  },
  {
    id: 3,
    community_id: 2,
    name: '江景两房两厅',
    image: '',
    suitable_guests: '2-4人',
    area: '约88㎡',
    description: '推窗见漓江，晚风伴入眠',
    facilities: ['双床', '免费WIFI', '空调', '电视', '洗衣机'],
    sort: 10,
    status: 1,
    created_at: '2026-09-06 10:00:00',
    updated_at: '2026-09-06 10:00:00'
  }
]

export function roomStatusText(status) {
  const item = STAY_ROOM_STATUS.find(s => s.value === status)
  return item ? item.label : String(status)
}

export function roomStatusTagType(status) {
  const item = STAY_ROOM_STATUS.find(s => s.value === status)
  return item ? item.tagType : 'info'
}

export function communityLabel(communityId) {
  const item = ROOM_COMMUNITY_OPTIONS.find(o => o.value === communityId)
  return item ? item.label : String(communityId)
}
